import { AbstractPreloaderProperties } from "@lib/titan2/dist/game/view/properties/AbstractPreloaderProperties";
import * as PIXI from "pixi.js";
import { LoaderLandscapeProperties } from "../landscape/LoaderLandscapeProperties";
import { GameLoaderFontStyle } from "@lib/js-slingo-pawnshop-core/dist";
/**
 * LoaderPortraitProperties.ts
 */
export class LoaderPortraitProperties extends LoaderLandscapeProperties {
    equals(other) {
        return super.equals(other);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.copyrightProperties = this.copyrightProperties.copyTo(GameLoaderFontStyle.COPYRIGHT_PORTRAIT);
        this.playButtonProperties.position.set(312, 1576);
        this.playButtonProperties.scale.set(1.2);
        this.progressBarBackgroundProperties.position.set(312, 1635);
        this.progressBarForegroundProperties.position.set(321, 1638);
        this.backgroundProperties.anchor.set(0.5, 0.5);
        this.enLocaleWinContainer.position.set(64, 697);
        this.enLocaleWinContainer.scale.set(1.1, 1.1);
        this.genericWinProperties.setMultiline(true);
        this.genericWinProperties.scale.set(1.1);
        this.genericWinProperties.position.set(325, 708);
        this.genericWinProperties.size.set(500, 290);
        this.genericSlingoProperties.position.set(512, 1035);
        this.genericSlingoProperties.size.set(510, 290);
        this.genericSlingoProperties.scale.set(1.2);
        this.infoFieldFooterProperties.position.set(512, 1778);
        this.infoFieldFooterProperties.size.set(900, 100);
        this.copyrightProperties.size = new PIXI.Point(1024, 75);
        this.copyrightProperties.position.set(512, 1874);
        this.versionFieldProperties.position.set(984, 1716);
    }
}
export class PreloaderPortraitProperties extends AbstractPreloaderProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spineProperties.position = new PIXI.Point(500, 900);
        this.messageSpinePosition = new PIXI.Point(875, 349);
        this.messageProperties.position = new PIXI.Point(665, 550);
        this.messageProperties.size = new PIXI.Point(940, 220);
        this.messageProperties.multiline = true;
    }
}
